import axios from "axios";
import { useEffect, useState } from "react";
import GitHubCalendar from "react-github-calendar";
import RepoCard from "../components/RepoCard";
import styles from "../styles/GithubPage.module.css";

const GithubPage = () => {
  const theme = {
    level0: "#161B22",
    level1: "#0e4429",
    level2: "#006d32",
    level3: "#26a641",
    level4: "#39d353",
  };
  const [user, _user] = useState();
  const [repos, _repos] = useState();

  const getDataHandler = async () => {
    try {
      const resp = await axios.get(`https://api.github.com/users/gyanish0`);
      if (resp.status === 200) {
        _user(resp.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getProfileHandler = async () => {
    try {
      const resp = await axios.get(
        `https://api.github.com/users/gyanish0/repos?per_page=100`
      );
      if (resp.status === 200) {
        _repos(resp.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getDataHandler();
    getProfileHandler();
  }, []);

  return (
    <>
      <div className={styles.user}>
        <div>
          <img
            src={user?.avatar_url}
            className={styles.avatar}
            alt={user?.login}
            width={50}
            height={50}
          />
          <h3 className={styles.username}>{user?.login}</h3>
        </div>
        <div>
          <h3>{user?.public_repos} repos</h3>
        </div>
        <div>
          <h3>{user?.followers} followers</h3>
        </div>
      </div>
      <div className={styles.container}>
        {repos && repos.length > 0
          ? repos.map((repo) => <RepoCard key={repo.id} repo={repo} />)
          : ""}
      </div>
      <div className={styles.contributions}>
        <GitHubCalendar
          username="gyanish0"
          theme={theme}
          hideColorLegend
          hideMonthLabels
        />
      </div>
    </>
  );
};

// export async function getStaticProps() {
//   const userRes = await fetch(`https://api.github.com/users/gyanish0`, {
//     headers: {
//       Authorization: `token ${process.env.GITHUB_API_KEY}`,
//     },
//   });
//   const user = await userRes.json();

//   const repoRes = await fetch(
//     `https://api.github.com/users/gyanish0/repos?per_page=100`,
//     {
//       headers: {
//         Authorization: `token ${process.env.GITHUB_API_KEY}`,
//       },
//     }
//   );
//   let repos = await repoRes.json();
//   repos = repos
//     .sort((a, b) => b.stargazers_count - a.stargazers_count)
//     .slice(0, 6);

//   return {
//     props: { title: "GitHub", repos, user },
//     revalidate: 10,
//   };
// }

export default GithubPage;
